import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { prizeService, pointsService } from '../../services';
import { useAuth } from '../../contexts/AuthContext';
import type { Prize } from '../../types';
import styles from './Prizes.module.css';

export const Prizes: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const navigate = useNavigate();
  const { customer, refreshCustomer } = useAuth();
  const [prizes, setPrizes] = useState<Prize[]>([]);
  const [loading, setLoading] = useState(true);
  const [redeeming, setRedeeming] = useState<number | null>(null);

  const cId = parseInt(companyId || '0');
  const card = customer?.loyaltyCards.find((c) => c.companyId === cId);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await prizeService.getPrizes(cId);
        setPrizes(data);
      } catch (err) {
        console.error('Errore caricamento premi:', err);
      } finally {
        setLoading(false);
      }
    };
    if (cId) load();
  }, [cId]);

  const handleRedeem = async (prize: Prize) => {
    if (!card) return;
    if (card.pointsBalance < prize.pointsCost) {
      alert('Punti insufficienti');
      return;
    }
    if (!window.confirm(`Riscattare "${prize.name}" per ${prize.pointsCost} punti?`)) return;

    setRedeeming(prize.id);
    try {
      await pointsService.redeemPrize(prize.id, cId);
      await refreshCustomer();
      alert('Premio riscattato con successo!');
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Errore nel riscatto';
      alert(message);
    } finally {
      setRedeeming(null);
    }
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <button className={styles.back} onClick={() => navigate('/')}>
          ← Indietro
        </button>
        <h1>Catalogo Premi</h1>
        {card && <p className={styles.balance}>{card.pointsBalance} punti disponibili</p>}
      </header>

      {loading ? (
        <p className={styles.loading}>Caricamento...</p>
      ) : prizes.length === 0 ? (
        <p className={styles.empty}>Nessun premio disponibile al momento</p>
      ) : (
        <div className={styles.grid}>
          {prizes.map((prize) => (
            <div key={prize.id} className={styles.prizeCard}>
              <div className={styles.prizeInfo}>
                <h3>{prize.name}</h3>
                {prize.description && <p className={styles.desc}>{prize.description}</p>}
              </div>
              <div className={styles.prizeFooter}>
                <span className={styles.cost}>{prize.pointsCost} pt</span>
                <button
                  className={styles.redeemBtn}
                  onClick={() => handleRedeem(prize)}
                  disabled={!card || card.pointsBalance < prize.pointsCost || redeeming === prize.id}
                >
                  {redeeming === prize.id ? '...' : 'Riscatta'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
